<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-shopping-bag"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'vendas.headings.titulo_pagina' | translate }}</h1>
    <p class="header-subtitle">{{ 'vendas.texts.subtitulo_pagina' | translate }}</p>
  </div>
  <div class="header-actions">
    <button
      pButton
      type="button"
      icon="pi pi-info-circle"
      [label]="'vendas.tooltips.atalhos_teclado' | translate"
      class="p-button-text btn-ajuda-atalhos"
      (click)="abrirDialogAtalhos()">
    </button>
  </div>
</div>

<div class="container">
  <div class="tabPanel-container">
    <!-- COLUNA ESQUERDA (lista de produtos) -->
    <div class="item item1">

      <!-- Chips de Categoria (substitui p-dropdown) -->
      <div class="categorias-chips-container">
        <div class="chips-scroll">
          <!-- Setas: aparecem só no lado que tem categoria escondida -->
          <button
            type="button"
            class="chips-scroll-nav chips-scroll-nav-esquerda"
            [disabled]="!dsCategorias.podeRolarEsquerda"
            [attr.aria-label]="'common.chips_scroll.anterior' | translate"
            (click)="dsCategorias.rolar(-1)">
            <i class="pi pi-chevron-left" aria-hidden="true"></i>
          </button>

          <div
            class="categorias-chips chips-scroll-viewport"
            appDragScroll
            #dsCategorias="appDragScroll"
            [class.tem-esquerda]="dsCategorias.podeRolarEsquerda"
            [class.tem-direita]="dsCategorias.podeRolarDireita">
            <button
              *ngFor="let grupo of grupos"
              class="chip-categoria"
              [class.chip-ativo]="categoriaSelecionada?.id === grupo.id"
              (click)="selecionarCategoria(grupo)">
              <img
                *ngIf="grupo.imagem"
                class="chip-categoria-img"
                [src]="env.imgHost + '/' + idEmpresa + '/grupo/' + grupo.imagem"
                [alt]="grupo.nome"
                (error)="onImageError($event)" />
              <i *ngIf="!grupo.imagem && grupo.id !== null" class="pi pi-th-large chip-categoria-icon"></i>
              <i *ngIf="grupo.id === null" class="pi pi-list chip-categoria-icon"></i>
              <span *ngIf="grupo.id !== null">{{ grupo.nome }}</span>
              <span *ngIf="grupo.id === null">{{ 'vendas.labels.todas_categorias' | translate }}</span>
            </button>
          </div>

          <button
            type="button"
            class="chips-scroll-nav chips-scroll-nav-direita"
            [disabled]="!dsCategorias.podeRolarDireita"
            [attr.aria-label]="'common.chips_scroll.proximo' | translate"
            (click)="dsCategorias.rolar(1)">
            <i class="pi pi-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>

      <!-- Busca + Checkbox na mesma linha -->
      <div class="search-bar">
        <div class="search-bar-row">
          <div class="search-field-wrapper search-field">
            <p-iconField iconPosition="right">
              <p-inputIcon styleClass="pi pi-search" />
              <input #searchInput type="text" (input)="onInputChange($event)" (keydown.enter)="onSearchEnter($event)" pInputText
                [disabled]="mostrarDialogSelecaoMultiplicador"
                [placeholder]="'vendas.placeholders.buscar_por_nome_ou_codigo' | translate" class="w-full" />
            </p-iconField>
            <kbd class="search-kbd">F2</kbd>
          </div>
          <div class="checkbox-sem-saldo">
            <p-checkbox
              inputId="ck-sem-saldo"
              [(ngModel)]="mostrarSemSaldo"
              binary="true"
              (onChange)="onToggleSemSaldo()">
            </p-checkbox>
            <label for="ck-sem-saldo">{{ 'vendas.labels.mostrar_itens_sem_saldo' | translate }}</label>
          </div>

          <!-- Qual codigo aparece no card e na linha do carrinho (nenhum por padrao) -->
          <div class="seletor-codigo">
            <label for="dd-codigo">{{ 'vendas.labels.codigo_exibir' | translate }}</label>
            <p-dropdown
              inputId="dd-codigo"
              [options]="codigoOptions"
              optionLabel="label"
              optionValue="value"
              [(ngModel)]="exibicaoCodigo"
              (ngModelChange)="onExibicaoCodigoChange()"
              appendTo="body"
              styleClass="dd-codigo">
            </p-dropdown>
          </div>
        </div>
      </div>

      <!-- Grid de produtos (oculta quando não encontrado) -->
      <div class="produtos-grid" *ngIf="!loading && !produtoNaoEncontrado; else skeleton">
        <div
          class="produto-item"
          *ngFor="let produto of produtos"
          tabindex="0"
          [pTooltip]="'vendas.tooltips.adicionar_produto' | translate"
          tooltipPosition="top"
          [class.disabled-card]="!podeClicar(produto)"
          (click)="podeClicar(produto) && adicionarProduto(produto)"
          (keydown.enter)="podeClicar(produto) && adicionarProduto(produto)">

          <!-- Badge de servico (overlay no topo do card) -->
          <span *ngIf="ehServico(produto)" class="badge-servico-overlay">
            {{ 'vendas.small.servico' | translate }}
          </span>

          <!-- Container de imagem com aspect-ratio fixo -->
          <!-- Clique na imagem abre o dialog de detalhe (carrossel + qtd + add) -->
          <div class="produto-img-container"
               tabindex="0"
               (click)="abrirDetalheProdutoEvento($event, produto)"
               (keydown.enter)="abrirDetalheProdutoEvento($event, produto)">
            <img
              [src]="env.imgHost + '/' + idEmpresa + '/item/' + produto.imagem"
              [alt]="produto.nome"
              [attr.data-product-id]="produto.id"
              (error)="onImageError($event)"
              [class.img-hidden]="temErroImagem(produto)" />
            <!-- SVG Placeholder (exibido quando imagem falha) -->
            <svg *ngIf="temErroImagem(produto)"
                 class="placeholder-svg" viewBox="0 0 160 90" fill="none"
                 xmlns="http://www.w3.org/2000/svg"
                 aria-hidden="true">
              <rect width="160" height="90" rx="8" class="placeholder-bg"/>
              <rect x="55" y="25" width="50" height="40" rx="4" class="placeholder-border"
                    stroke-width="2" fill="none"/>
              <path d="M65 55l8-10 6 6 14-16v20H65z" class="placeholder-icon"/>
              <circle cx="72" cy="35" r="4" class="placeholder-icon"/>
            </svg>
          </div>

          <!-- Informacoes do produto -->
          <h3 class="produto-nome">{{ produto.nome }}</h3>
          <p class="produto-cod" *ngIf="textoDoCodigo(produto, exibicaoCodigo) as cod">{{ cod }}</p>

          <!-- Preco em destaque -->
          <p class="produto-preco" *ngIf="moedaPadrao === 'PYG'">{{ produto.precoDeVenda | guaraniFormat }}</p>
          <p class="produto-preco" *ngIf="moedaPadrao !== 'PYG'">
            {{ produto.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
          </p>

          <!-- Badge de estoque (pill semantica) -->
          <div class="estoque-info" *ngIf="ehServico(produto); else mercInfo">
            <span class="badge-estoque badge-servico">
              {{ 'vendas.small.servico' | translate }}
            </span>
          </div>
          <ng-template #mercInfo>
            <span *ngIf="!indisponivel(produto)" class="badge-estoque badge-disponivel">
              {{ 'vendas.labels.em_estoque' | translate }} {{ produto.saldo | number:'1.0-0' }}
            </span>
            <span *ngIf="indisponivel(produto)" class="badge-estoque badge-indisponivel">
              {{ 'vendas.small.indisponivel' | translate }}
            </span>
          </ng-template>
        </div>

        <div *ngIf="produtos.length === 0" class="vm-empty-state" style="padding: 48px 16px; grid-column: 1 / -1; text-align: center;">
          <i class="pi pi-box" style="font-size: 2rem;"></i>
          <span>{{ 'vendas.texts.produto_nao_encontrado' | translate }}</span>
        </div>
      </div>

      <div *ngIf="!loading && produtoNaoEncontrado" class="vm-empty-state" style="padding: 48px 16px;">
        <i class="pi pi-box" style="font-size: 2rem;"></i>
        <span>{{ 'vendas.texts.produto_nao_encontrado' | translate }}</span>
      </div>

      <!-- Skeleton Loader -->
      <ng-template #skeleton>
        <div class="produtos-grid" *ngIf="!produtoNaoEncontrado">
          <div class="skeleton-card" *ngFor="let i of [1,2,3,4,5,6,7,8]">
            <!-- Imagem (aspect-ratio 16/9, border-radius 8px) -->
            <div class="skeleton-img-container">
              <p-skeleton width="100%" height="100%" borderRadius="0"></p-skeleton>
            </div>
            <!-- Nome do produto (2 linhas) -->
            <p-skeleton width="90%" height="14px" styleClass="skeleton-nome-linha1"></p-skeleton>
            <p-skeleton width="60%" height="14px"></p-skeleton>
            <!-- Codigo -->
            <p-skeleton width="40%" height="10px" styleClass="skeleton-cod"></p-skeleton>
            <!-- Preco -->
            <p-skeleton width="50%" height="20px" styleClass="skeleton-preco"></p-skeleton>
            <!-- Badge de estoque -->
            <p-skeleton width="55%" height="22px" borderRadius="12px" styleClass="skeleton-badge"></p-skeleton>
          </div>
        </div>
      </ng-template>

      <!-- Paginação (não aparece quando "não encontrado") — mesmo padrão das
           demais telas (ver lista-de-produtos / pedidos): contagem + navegação
           à esquerda, "Itens por página" à direita. O seletor de tamanho sai de
           dentro do p-paginator e vira dropdown rotulado, senão fica um "10"
           solto sem dizer do que se trata. -->
      <div class="pagination-container" *ngIf="!produtoNaoEncontrado">
        <div>
          <p-paginator
            [rows]="tamanhoPagina"
            [totalRecords]="totalElements"
            [first]="paginaAtual * tamanhoPagina"
            (onPageChange)="onPaginatorChange($event)"
            [showCurrentPageReport]="true"
            [currentPageReportTemplate]="'vendas.table.contagem' | translate"
            [showFirstLastIcon]="true">
          </p-paginator>
        </div>
        <div class="flex align-items-center">
          <span class="mx-1 text-color">{{ 'vendas.labels.itens_por_pagina' | translate }}</span>
          <p-dropdown
            [options]="pageSizeOptions"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="tamanhoPagina"
            (ngModelChange)="onRowsPerPageChange()"
            styleClass="w-6rem">
          </p-dropdown>
        </div>
      </div>
    </div>

    <!-- COLUNA DIREITA (carrinho / pagamento) -->
    <div class="item item2">
      <p-card id="pagamentoVendas">
        <!-- Bloco seleção/ações -->
        <div class="customer-card">
          <!-- 1ª linha: Timbrado -->
          <div class="campo-vendas">
            <label>{{ 'vendas.labels.timbrado' | translate }} <kbd>F7</kbd></label>
            <p-dropdown
              #timbradoDD
              [options]="timbrados"
              [(ngModel)]="timbradoSelecionadoId"
              optionLabel="label"
              optionValue="id"
              [scrollHeight]="'320px'"
              [placeholder]="'vendas.placeholders.selecione_o_timbrado' | translate"
              (onChange)="onTimbradoChange($event)">
              <!-- Item selecionado -->
              <ng-template pTemplate="selectedItem" let-opt>
                <div *ngIf="opt">{{ opt.label }}</div>
              </ng-template>

              <!-- Itens da lista -->
              <ng-template pTemplate="item" let-opt>
                <div>{{ opt.label }}</div>
              </ng-template>
            </p-dropdown>
          </div>

          <!-- 2ª linha: Cliente -->
          <div class="campo-vendas">
            <label class="cliente-label-row">
              <span>{{ 'vendas.labels.cliente' | translate }} <kbd>F3</kbd></span>
              <span class="atalho-novo-cliente" (click)="abrirDialogNovoCliente()" style="cursor: pointer;">{{ 'vendas.labels.novo_cliente_atalho' | translate }} <kbd>F9</kbd></span>
            </label>
            <div class="cliente-input-row">
              <app-entity-selector #clienteSelector
                [config]="clienteSelectorConfig"
                [(value)]="clienteSelecionado"
                (entitySelected)="onClienteSelecionado($event)"
                (addNew)="abrirDialogNovoCliente()">
              </app-entity-selector>
            </div>
          </div>

          <!--
            Importar pedido e Limpar carrinho se alternam no mesmo lugar: faturar um pedido e uma
            venda, e so faz sentido puxar um pedido com o carrinho vazio. Para trocar de pedido, o
            operador esvazia o carrinho e importa outro.
          -->
          <button
            *ngIf="carrinho.length === 0 && podeImportarPedido"
            pButton
            icon="pi pi-file-import"
            class="btn-importar-pedido"
            (click)="abrirImportarPedido()">
            {{ 'vendas.buttons.importar_pedido' | translate }} <kbd>F10</kbd>
          </button>

          <!-- Botao "Limpar Carrinho" -->
          <button
            *ngIf="carrinho.length > 0"
            pButton
            class="btn-limpar-carrinho"
            (click)="abrirConfirmacaoCancelarPedido()">
            {{ 'vendas.buttons.limpar_carrinho' | translate }}
            <span class="atalho-desktop">(Ctrl+Shift+Del)</span>
          </button>
        </div>

        <!-- Tabela do Carrinho -->
        <span *ngIf="carrinho.length == 0">{{ 'vendas.spans.nenhum_produto_selecionado' | translate }}</span>

        <div class="tabela-itens cart-table" *ngIf="carrinho.length > 0">
          <table>
            <thead>
              <tr>
                <th>{{ 'vendas.table.item' | translate }}</th>
                <th class="text-center">{{ 'vendas.table.qtd' | translate }}</th>
                <th class="text-right">{{ 'vendas.table.preco' | translate }}</th>
                <th class="text-right">{{ 'vendas.table.total' | translate }}</th>
                <th class="text-center">{{ 'vendas.table.acao' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of carrinho">
                <!-- NOME DO ITEM -->
                <td>
                  <div class="cart-item-cell" [pTooltip]="item.nome" tooltipPosition="left">
                    <span class="cart-item-name">{{ item.nome }}</span>
                    <small class="cart-item-cod" *ngIf="textoDoCodigo(item, exibicaoCodigo) as cod">
                      {{ cod }}
                    </small>
                    <small *ngIf="item.varianteDescricao || item.modificadoresDescricao" class="cart-item-detalhes">
                      <span *ngIf="item.varianteDescricao">
                        {{ 'vendas.variantes.variante' | translate }}: {{ item.varianteDescricao }}
                      </span>
                      <span *ngIf="item.varianteDescricao && item.modificadoresDescricao"> | </span>
                      <span *ngIf="item.modificadoresDescricao">
                        {{ 'vendas.variantes.adicionais' | translate }}: {{ item.modificadoresDescricao }}
                      </span>
                    </small>

                    <!-- Observacao manual do item (paridade com Criar Pedido) -->
                    <div class="cart-item-obs-manual">
                      <!-- Preenchida: texto + icone de edicao -->
                      <button
                        *ngIf="temObservacaoManual(item); else chipAddObs"
                        type="button"
                        class="obs-manual-preenchida"
                        [pTooltip]="'criar_pedido.observacao_item_editar' | translate"
                        tooltipPosition="top"
                        (click)="abrirObservacaoItem(item)">
                        <i class="pi pi-pencil"></i>
                        <span class="obs-manual-texto">{{ item.observacaoManual }}</span>
                      </button>
                      <!-- Vazia: chip "Adicionar observacao" -->
                      <ng-template #chipAddObs>
                        <button
                          type="button"
                          class="obs-manual-chip"
                          (click)="abrirObservacaoItem(item)">
                          <i class="pi pi-comment"></i>
                          <span>{{ 'criar_pedido.observacao_item_adicionar' | translate }}</span>
                        </button>
                      </ng-template>
                    </div>
                  </div>
                </td>

                <td>
                  <div class="quantidade-controles">
                    <button
                      pButton
                      type="button"
                      icon="pi pi-minus"
                      class="btn-decrementar"
                      (click)="decrementarQuantidade(item)">
                    </button>
                    <input
                      type="number"
                      [(ngModel)]="item.quantidade"
                      (change)="atualizarValores(item)"
                      [max]="item.saldo"
                      min="1"
                      class="input-quantidade-carrinho" />
                    <button
                      pButton
                      type="button"
                      icon="pi pi-plus"
                      class="btn-incrementar"
                      (click)="incrementarQuantidade(item)">
                    </button>
                  </div>
                </td>

                <td class="text-right" *ngIf="moedaPadrao === 'PYG'">{{ item.valorUnitario | guaraniFormat }}</td>
                <td class="text-right" *ngIf="moedaPadrao !== 'PYG'">
                  {{ item.valorUnitario | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
                </td>

                <td class="text-right" *ngIf="moedaPadrao === 'PYG'">{{ item.valorTotalComDesconto | guaraniFormat }}</td>
                <td class="text-right" *ngIf="moedaPadrao !== 'PYG'">
                  {{ item.valorTotalComDesconto | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
                </td>

                <td>
                  <button
                    pButton
                    icon="pi pi-trash"
                    class="btn-remover-item"
                    (click)="confirmarRemocaoItem(item)">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Resumo financeiro refatorado -->
        <div class="payment-summary">
          <div class="summary-line">
            <span>{{ 'vendas.texts.subtotal' | translate }}</span>
            <span *ngIf="moedaPadrao === 'PYG'">{{ calcularSubtotal() | guaraniFormat }}</span>
            <span *ngIf="moedaPadrao !== 'PYG'">
              {{ calcularSubtotal() | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
            </span>
          </div>

          <div class="summary-line summary-desconto">
            <span>
              {{ 'vendas.texts.descontos' | translate }}
              <kbd>Ctrl</kbd> + <kbd>D</kbd>
              <i class="pi pi-pencil icon-pencil"
                 (click)="abrirDialogDesconto()"
                 [pTooltip]="'vendas.tooltips.editar_descontos' | translate"
                 tooltipPosition="left"></i>
            </span>
            <span *ngIf="moedaPadrao === 'PYG'">{{ descontos | guaraniFormat }}</span>
            <span *ngIf="moedaPadrao !== 'PYG'">
              {{ descontos | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
            </span>
          </div>

          <div class="summary-total">
            <span class="total-label">{{ 'vendas.texts.total' | translate }}</span>
            <span class="total-valor" *ngIf="moedaPadrao === 'PYG'">{{ (subtotal - descontos) | guaraniFormat }}</span>
            <span class="total-valor" *ngIf="moedaPadrao !== 'PYG'">
              {{ (subtotal - descontos) | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}
            </span>
          </div>
        </div>

        <!-- Observação -->
        <div class="observacao-container">
          <label for="observacao">{{ 'vendas.labels.observacao' | translate }} <kbd>F4</kbd></label>
          <textarea
            #observacaoInput
            id="observacao"
            [(ngModel)]="observacao"
            (ngModelChange)="salvarCache()"
            [placeholder]="'vendas.placeholders.adicione_uma_observacao_ao_pedido' | translate">
          </textarea>
        </div>


        <!-- Ações -->
        <div class="payment-actions">
          <button
            pButton
            class="p-button btn-finalizar"
            (click)="finalizarPedido()">
            {{ 'vendas.buttons.finalizar_venda' | translate }}
            (Ctrl+Enter)
          </button>
        </div>
      </p-card>
    </div>
  </div>
</div>

<!-- Dialog Forma de Pagamento (Componente reutilizavel) -->
<app-forma-pagamento-dialog
  [(visible)]="mostrarDialogPagamento"
  [totalAPagar]="subtotal - descontos"
  [config]="{
    formasPermitidas: ['dinheiro', 'conta', 'prazo', 'cartao', 'qrcode'],
    moedaPadrao: moedaPadrao,
    habilitarMultiMoeda: true,
    cotacoes: { cotUSD: cotUSD, cotPYG: cotPYG, cotBRL: cotBRL, cotPesoGuarani: cotPesoGuarani, cotRealGuarani: cotRealGuarani },
    labelBotaoConfirmar: ('vendas.buttons.realizar_venda' | translate),
    iconeBotaoConfirmar: 'pi pi-check'
  }"
  [contas]="contas"
  [contasTarjetaQrcode]="contasTarjetaQrcode"
  [bancardConfigurado]="bancardConfigurado"
  [contaQrCode]="contaQrCode"
  [estadoQrCode]="estadoQrCode"
  [moedaNota]="moedaNotaEnum"
  [processando]="processandoVenda"
  (gerarQrCode)="onGerarQrCode()"
  (cancelarQrCode)="limparEstadoQrCode()"
  (confirmar)="onPagamentoConfirmado($event)"
  (cancelar)="fecharDialogPagamento()">
</app-forma-pagamento-dialog>



<!-- Dialog Desconto -->
<p-dialog
  [(visible)]="mostrarDialogDesconto"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '400px', height: 'auto' }"
  (onShow)="onDialogDescontoShow()"
>
  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-percentage" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.dialogs.adicionar_desconto' | translate }}</h2>
        <p>{{ 'vendas.dialogs.adicionar_desconto_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <div class="field">
      <label>{{ 'vendas.labels.tipo_de_desconto' | translate }}</label>
      <p-dropdown
        #tipoDescDD
        [(ngModel)]="tipoDeDesconto"
        [options]="tiposDeDesconto"
        [placeholder]="'vendas.placeholders.selecione' | translate"
        optionLabel="label"
        [appendTo]="'body'"
        panelStyleClass="dropdown-panel-above-modal"
        (onShow)="focarDropdownDesconto()"
        (onChange)="onTipoDeDescontoChange($event.value)">
      </p-dropdown>
    </div>

    <div class="field" *ngIf="tipoDeDesconto?.value === 'VALOR'">
      <label>{{ 'vendas.labels.valor' | translate }}</label>
      <p-inputNumber
        #valorDescontoInput
        [(ngModel)]="valorDesconto"
        [currency]="moedaPadrao"
        [locale]="localeMoeda"
        [minFractionDigits]="casasDecimaisDaMoeda()"
        [maxFractionDigits]="casasDecimaisDaMoeda()"
        [useGrouping]="true"
        [min]="0"
        inputStyleClass="w-full"
        styleClass="w-full"
        (onInput)="validarValorDesconto(); salvarCache()">
      </p-inputNumber>
    </div>

    <div class="field" *ngIf="tipoDeDesconto?.value === 'PERCENTUAL'">
      <label>{{ 'vendas.labels.valor' | translate }}</label>
      <p-inputNumber
        #valorDescontoInput
        [(ngModel)]="valorDesconto"
        suffix="%"
        [minFractionDigits]="0"
        [maxFractionDigits]="2"
        [min]="0"
        [max]="100"
        inputStyleClass="w-full"
        styleClass="w-full"
        (onInput)="validarValorDesconto(); salvarCache()">
      </p-inputNumber>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="cancelarDesconto()">
      {{ 'vendas.buttons.cancelar' | translate }} (Esc)
    </button>
    <button pButton (click)="aplicarDesconto()">
      {{ 'vendas.buttons.aplicar' | translate }} (Enter)
    </button>
  </ng-template>
</p-dialog>

<!-- NOVO: Dialog para produto com preço 0 -->
<p-dialog
  [(visible)]="mostrarDialogPreco"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '420px', height: 'auto' }">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-tag" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.dialogs.definir_preco_venda' | translate }}</h2>
        <p>{{ 'vendas.dialogs.definir_preco_venda_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <div>
      <label>{{ 'vendas.labels.preco_venda_atual' | translate }}</label>
      <p style="margin: 4px 0 12px 0;">
        <strong>{{ precoVendaAtualFormatado }}</strong>
      </p>
    </div>

    <label for="novoPreco">{{ 'vendas.labels.novo_preco_de_venda' | translate }}</label>
    <input
      id="novoPreco"
      type="text"
      pInputText
      [value]="precoVendaNovoStr"
      (input)="onNovoPrecoInput($event)"
      (keydown.enter)="confirmarNovoPreco()"
      #inputNovoPreco />
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="cancelarNovoPreco()">
      {{ 'vendas.buttons.cancelar' | translate }} (Esc)
    </button>
    <button pButton icon="pi pi-save" (click)="confirmarNovoPreco()">
      {{ 'vendas.buttons.salvar' | translate }} (Enter)
    </button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>

<!-- Dialog Novo Cliente (F9) -->
<app-pessoa-adicionar-dialog
  [(visible)]="mostrarDialogNovoCliente"
  tipo="cliente"
  (pessoaCriada)="onClienteCriado($event)"
  (pessoaVinculada)="onClienteVinculado($event)">
</app-pessoa-adicionar-dialog>

<!-- Dialogo Fatura Pos-Venda -->
<p-dialog
  [(visible)]="mostrarDialogoFatura"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [focusOnShow]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '650px', 'max-height': '95vh' }">

  <!-- HEADER WAVE (variante success - venda concluida) -->
  <div class="dialog-wave-header dialog-wave-header--success">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-check-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.dialogs.fatura_gerada' | translate }}</h2>
        <p>{{ 'vendas.dialogs.fatura_gerada_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO -->
  <div class="dialog-wave-body" *ngIf="!carregandoFatura && notaCarregada">

    <!-- Informacoes do Cliente -->
    <div class="fatura-dialog-section">
      <div class="fatura-dialog-section-label">
        <i class="pi pi-user"></i>
        {{ 'vendas.labels.informacoes_do_cliente' | translate }}
      </div>
      <div class="fatura-dialog-pessoa">
        {{ notaCarregada.pessoa_id }} - {{ notaCarregada.nomePessoa }}
      </div>
    </div>

    <!-- Ticket + Data -->
    <div class="fatura-dialog-ticket">
      <span class="fatura-dialog-ticket-badge">
        <i class="pi pi-ticket"></i>
        TICKET # {{ notaCarregada.codigoNota }}
      </span>
      <span class="fatura-dialog-ticket-date">
        <i class="pi pi-calendar"></i>
        {{ formatarDataEHoraDialog(notaCarregada.emissaoFatura) }}
      </span>
    </div>

    <!-- Tabela de Itens -->
    <div class="fatura-dialog-section">
      <div class="fatura-dialog-section-label">
        <i class="pi pi-list"></i>
        {{ 'vendas.labels.itens_da_nota' | translate }}
      </div>
      <table class="fatura-dialog-table" *ngIf="itensCarregados.length > 0">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'vendas.labels.imagem' | translate }}</th>
            <th>{{ 'vendas.labels.item_nome' | translate }}</th>
            <th class="text-right">{{ 'vendas.labels.quantidade' | translate }}</th>
            <th class="text-right">{{ 'vendas.labels.valor_total_item' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of notaCarregada.itemDeNota; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <img *ngIf="itensCarregados[i]?.imagem"
                class="fatura-dialog-item-img"
                [src]="env.imgHost + '/' + idEmpresa + '/item/' + itensCarregados[i].imagem"
                [alt]="itensCarregados[i].nome"
                [attr.data-product-id]="itensCarregados[i].id"
                (error)="onImageError($event)" />
            </td>
            <td>
              {{ itensCarregados[i].nome || '---' }}
              <!-- Observacao do item (digitada no carrinho) -->
              <div *ngIf="observacaoVisivelDoItem(item, itensCarregados[i]?.nome) as obs" class="fatura-dialog-item-obs">
                <i class="pi pi-comment"></i>
                <span>{{ obs }}</span>
              </div>
            </td>
            <td class="text-right">{{ item.quantidade }}</td>
            <td class="text-right">{{ formatarValorMonetarioDialog(item.valorTotal, notaCarregada.moeda) }}</td>
          </tr>
        </tbody>
      </table>
      <p *ngIf="itensCarregados.length === 0" class="fatura-dialog-empty">
        {{ 'vendas.labels.nenhum_item_encontrado' | translate }}
      </p>
    </div>

    <!-- Resumo Financeiro -->
    <div class="fatura-dialog-resumo">
      <div class="fatura-dialog-resumo-line">
        <span>{{ 'vendas.texts.subtotal' | translate }}</span>
        <span>{{ formatarValorMonetarioDialog(notaCarregada.valorTotal, notaCarregada.moeda) }}</span>
      </div>
      <div class="fatura-dialog-resumo-line fatura-dialog-resumo-desconto" *ngIf="notaCarregada.valorDoDesconto">
        <span>{{ 'vendas.texts.descontos' | translate }}</span>
        <span>- {{ formatarValorMonetarioDialog(notaCarregada.valorDoDesconto, notaCarregada.moeda) }}</span>
      </div>
      <div class="fatura-dialog-resumo-total">
        <span>{{ 'vendas.texts.total' | translate }}</span>
        <span>{{ formatarValorMonetarioDialog(notaCarregada.valorTotalComDesconto, notaCarregada.moeda) }}</span>
      </div>
    </div>

    <!-- Pagamento -->
    <div class="fatura-dialog-pagamento">
      <div class="fatura-dialog-pagamento-header">
        <i class="pi pi-wallet"></i>
        <span>{{ formatarCondicaoPagamento(notaCarregada.condicaoDePagamento) }}</span>
        <span *ngIf="!notaCarregada.numeroParcelas" class="fatura-dialog-badge-cash">
          {{ 'vendas.labels.em_efetivo' | translate }}
        </span>
        <span *ngIf="notaCarregada.numeroParcelas" class="fatura-dialog-badge-parcelas">
          {{ notaCarregada.numeroParcelas }}X
        </span>
      </div>
    </div>

    <!-- Observacao -->
    <div *ngIf="notaCarregada.observacao" class="fatura-dialog-observacao">
      <i class="pi pi-comment"></i>
      <span>{{ notaCarregada.observacao }}</span>
    </div>

    <!-- Formato de Impressao -->
    <div class="fatura-dialog-formato-impressao">
      <div class="fatura-dialog-formato-header">
        <i class="pi pi-print"></i>
        <span>{{ 'vendas.labels.formato_impressao' | translate }}</span>
      </div>
      <div class="formato-impressao-opcoes">
        <div class="p-field-radiobutton">
          <p-radioButton name="formatoImpressaoFatura" value="A4"
            [(ngModel)]="opcaoImpressaoFatura" inputId="fatura-fmt-a4">
          </p-radioButton>
          <label for="fatura-fmt-a4">A4</label>
        </div>
        <div class="p-field-radiobutton">
          <p-radioButton name="formatoImpressaoFatura" value="BOBINA_58"
            [(ngModel)]="opcaoImpressaoFatura" inputId="fatura-fmt-58">
          </p-radioButton>
          <label for="fatura-fmt-58">{{ 'vendas.labels.bobina_58mm' | translate }}</label>
        </div>
        <div class="p-field-radiobutton">
          <p-radioButton name="formatoImpressaoFatura" value="BOBINA_80"
            [(ngModel)]="opcaoImpressaoFatura" inputId="fatura-fmt-80">
          </p-radioButton>
          <label for="fatura-fmt-80">{{ 'vendas.labels.bobina_80mm' | translate }}</label>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div class="dialog-wave-body fatura-dialog-loading" *ngIf="carregandoFatura">
    <p-progressSpinner [style]="{ width: '50px', height: '50px' }"></p-progressSpinner>
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton
      class="p-button-secondary"
      (click)="fecharDialogoFatura()">
      {{ 'vendas.buttons.fechar' | translate }} (Esc)
    </button>
    <!-- Ficha do evento: so aparece com a opcao "Imprimir Ficha do Evento" ativa na empresa -->
    <button pButton
      *ngIf="deveImprimirFicha && notaCarregada"
      icon="pi pi-receipt"
      class="p-button-outlined"
      [loading]="isImprimindoFicha"
      [disabled]="carregandoFatura || isImprimindoFicha"
      (click)="imprimirFichaDialog()">
      {{ 'vendas.buttons.imprimir_ficha' | translate }}
    </button>
    <button pButton
      icon="pi pi-print"
      (click)="gerarPdfFaturaDialog()"
      [disabled]="carregandoFatura">
      {{ 'vendas.buttons.imprimir_fatura' | translate }} (Ctrl+P)
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog Remover Item -->
<p-dialog
  [(visible)]="mostrarDialogRemoverItem"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '400px', height: 'auto' }">

  <!-- HEADER CUSTOMIZADO COM WAVE (variante danger) -->
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.dialogs.remover_item_header' | translate }}</h2>
        <p>{{ 'vendas.dialogs.remover_item_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <p>{{ 'vendas.messages.remover_item_message' | translate:{ produto: itemParaRemover?.nome, producto: itemParaRemover?.nome } }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="cancelarRemocaoItem()">
      {{ 'vendas.common.nao' | translate }} (Esc)
    </button>
    <button pButton severity="danger" icon="pi pi-trash" (click)="confirmarRemocaoItemFinal()">
      {{ 'vendas.common.sim' | translate }} (Enter)
    </button>
  </ng-template>
</p-dialog>

<!-- Dialogo Impressao de Fatura -->
<p-dialog
  [(visible)]="mostrarDialogoImpressaoFatura"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '400px', height: 'auto' }"
  (onShow)="onDialogoImpressaoFaturaShow()">

  <!-- HEADER WAVE (variante info) -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-print" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.dialogs.impressao_fatura' | translate }}</h2>
        <p>{{ 'vendas.dialogs.impressao_fatura_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO -->
  <div class="dialog-wave-body">
    <div class="field" style="margin-top: 10px;">
      <div class="p-field-radiobutton" style="margin-bottom: 12px;">
        <p-radioButton name="impressaoFatura" value="A4" [(ngModel)]="opcaoImpressaoFatura" inputId="fatura-opt-a4"></p-radioButton>
        <label for="fatura-opt-a4" style="margin-left: 8px;">A4</label>
      </div>
      <div class="p-field-radiobutton" style="margin-bottom: 12px;">
        <p-radioButton name="impressaoFatura" value="BOBINA_58" [(ngModel)]="opcaoImpressaoFatura" inputId="fatura-opt-58"></p-radioButton>
        <label for="fatura-opt-58" style="margin-left: 8px;">{{ 'vendas.labels.bobina_58mm' | translate }}</label>
      </div>
      <div class="p-field-radiobutton">
        <p-radioButton name="impressaoFatura" value="BOBINA_80" [(ngModel)]="opcaoImpressaoFatura" inputId="fatura-opt-80"></p-radioButton>
        <label for="fatura-opt-80" style="margin-left: 8px;">{{ 'vendas.labels.bobina_80mm' | translate }}</label>
      </div>
    </div>
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton
      class="p-button-secondary"
      (click)="mostrarDialogoImpressaoFatura = false">
      {{ 'vendas.buttons.fechar' | translate }} (Esc)
    </button>
    <button pButton
      icon="pi pi-print"
      [loading]="isImprimindoFatura"
      (click)="gerarPdfFaturaDialog()"
      #btnImprimirFatura>
      {{ 'vendas.buttons.imprimir_fatura' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Dialogo Transmissao Automatica NFe -->
<p-dialog
  [(visible)]="mostrarDialogoTransmissao"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '700px', 'max-width': '98vw', height: 'auto' }">

  <!-- HEADER WAVE - muda cor conforme estado -->
  <div class="dialog-wave-header"
    [ngClass]="{
      'dialog-wave-header--info': transmissaoEstado === 'transmitindo',
      'dialog-wave-header--success': transmissaoEstado === 'sucesso',
      'dialog-wave-header--danger': transmissaoEstado === 'erro'
    }">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i [ngClass]="{
          'pi pi-send': transmissaoEstado === 'transmitindo',
          'pi pi-check-circle': transmissaoEstado === 'sucesso',
          'pi pi-exclamation-triangle': transmissaoEstado === 'erro'
        }" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2 *ngIf="transmissaoEstado === 'transmitindo'">
          {{ 'vendas.transmissao.titulo_transmitindo' | translate }}
        </h2>
        <h2 *ngIf="transmissaoEstado === 'sucesso'">
          {{ 'vendas.transmissao.titulo_sucesso' | translate }}
        </h2>
        <h2 *ngIf="transmissaoEstado === 'erro'">
          {{ 'vendas.transmissao.titulo_erro' | translate }}
        </h2>
        <p *ngIf="transmissaoEstado === 'transmitindo'">
          {{ 'vendas.transmissao.desc_transmitindo' | translate }}
        </p>
        <p *ngIf="transmissaoEstado === 'sucesso'">
          {{ 'vendas.transmissao.desc_sucesso' | translate }}
        </p>
        <p *ngIf="transmissaoEstado === 'erro'">
          {{ 'vendas.transmissao.desc_erro' | translate }}
        </p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO -->
  <div class="dialog-wave-body">
    <div class="transmissao-dialog-body">
      <!-- Estado: Transmitindo -->
      <div *ngIf="transmissaoEstado === 'transmitindo'" class="transmissao-status">
        <p-progressSpinner [style]="{ width: '60px', height: '60px' }"></p-progressSpinner>
        <p class="transmissao-mensagem">
          {{ 'vendas.transmissao.mensagem_transmitindo' | translate }}
        </p>
      </div>

      <!-- Estado: Sucesso -->
      <div *ngIf="transmissaoEstado === 'sucesso'" class="transmissao-status">
        <i class="pi pi-check-circle transmissao-icone-sucesso"></i>
        <p class="transmissao-mensagem transmissao-mensagem--sucesso">
          {{ 'vendas.transmissao.mensagem_sucesso' | translate }}
        </p>
      </div>

      <!-- Estado: Erro -->
      <div *ngIf="transmissaoEstado === 'erro'" class="transmissao-status">
        <i class="pi pi-times-circle transmissao-icone-erro"></i>
        <p class="transmissao-mensagem">
          {{ 'vendas.transmissao.mensagem_erro' | translate }}
        </p>
        <p *ngIf="transmissaoMensagem" class="transmissao-detalhe-erro">
          {{ transmissaoMensagem }}
        </p>
      </div>

      <!-- Barra de Progresso (transmitindo e sucesso) -->
      <div *ngIf="transmissaoEstado !== 'erro'" class="transmissao-progresso">
        <div class="flex justify-content-between align-items-center mb-2">
          <span class="text-700 text-sm">{{ 'vendas.transmissao.progresso' | translate }}</span>
          <span class="text-900 font-bold text-sm">{{ transmissaoProgresso }}%</span>
        </div>
        <p-progressBar [value]="transmissaoProgresso" [showValue]="false"></p-progressBar>
      </div>
    </div>
  </div>

  <!-- FOOTER - so aparece no estado de erro -->
  <ng-template pTemplate="footer">
    <ng-container *ngIf="transmissaoEstado === 'erro'">
      <button pButton class="p-button-secondary"
        (click)="fecharDialogoTransmissaoEVerFatura()">
        {{ 'vendas.transmissao.btn_fechar' | translate }} (Esc)
      </button>
      <button pButton icon="pi pi-send"
        (click)="retransmitirNfe()">
        {{ 'vendas.transmissao.btn_transmitir' | translate }} (T)
      </button>
      <button pButton icon="pi pi-external-link"
        (click)="irParaDetalhesFatura()">
        {{ 'vendas.transmissao.btn_ver_detalhes' | translate }} (Enter)
      </button>
    </ng-container>
  </ng-template>
</p-dialog>

<!-- Dialog Limpar Carrinho -->
<p-dialog
  [(visible)]="mostrarDialogLimparCarrinho"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '400px', height: 'auto' }"
  (onShow)="onDialogLimparCarrinhoShow()">

  <!-- HEADER CUSTOMIZADO COM WAVE (variante danger) -->
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.common.confirmacao' | translate }}</h2>
        <p>{{ 'vendas.dialogs.limpar_carrinho_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <p>{{ 'vendas.messages.confirmar_limpar_carrinho' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="fecharDialogLimparCarrinho()">
      {{ 'vendas.common.nao' | translate }} (Esc)
    </button>
    <button pButton severity="danger" icon="pi pi-trash" (click)="confirmarLimparCarrinho()" #btnConfirmarLimparCarrinho>
      {{ 'vendas.common.sim' | translate }} (Enter)
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog Dados Cliente NFe -->
<p-dialog
  [(visible)]="mostrarDialogDadosClienteNfe"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '450px', height: 'auto' }">

  <!-- HEADER CUSTOMIZADO COM WAVE (variante warning) -->
  <div class="dialog-wave-header dialog-wave-header--warning">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.dialogs.dados_cliente_nfe_header' | translate }}</h2>
        <p>{{ 'vendas.dialogs.dados_cliente_nfe_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <p>{{ 'vendas.mensagens.dados_cliente_nfe' | translate:{ campos: camposFaltantesNfe.join(', ') } }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-warning" icon="pi pi-user-edit" (click)="editarClienteNfe()">
      {{ 'vendas.dialogs.dados_cliente_nfe_editar' | translate }}
    </button>
    <button pButton icon="pi pi-check" (click)="prosseguirSemDadosClienteNfe()">
      {{ 'vendas.dialogs.dados_cliente_nfe_prosseguir' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog Atalhos de Teclado -->
<p-dialog
  [(visible)]="mostrarDialogAtalhos"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '600px', height: 'auto' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.dialogs.atalhos_teclado' | translate }}</h2>
        <p>{{ 'vendas.dialogs.atalhos_teclado_desc' | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body" style="padding: 0 24px 16px 24px;">
    <p-table
      [value]="[]"
      styleClass="p-datatable-sm atalhos-table"
      [tableStyle]="{ 'min-width': '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th style="width: 240px; white-space: nowrap;">{{ 'vendas.atalhos.coluna_atalho' | translate }}</th>
          <th>{{ 'vendas.atalhos.coluna_acao' | translate }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body">
        <!-- Este template nao sera renderizado pois [value] esta vazio -->
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <!-- Atalhos Gerais -->
        <tr class="atalhos-section-header">
          <td colspan="2"><strong>{{ 'vendas.atalhos.secao_geral' | translate }}</strong></td>
        </tr>
        <tr>
          <td><kbd>F2</kbd></td>
          <td>{{ 'vendas.atalhos.f2' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>F3</kbd></td>
          <td>{{ 'vendas.atalhos.f3' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>F4</kbd></td>
          <td>{{ 'vendas.atalhos.f4' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>F7</kbd></td>
          <td>{{ 'vendas.atalhos.f6' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>F8</kbd></td>
          <td>{{ 'vendas.atalhos.f8' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>F9</kbd></td>
          <td>{{ 'vendas.atalhos.f9' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>F10</kbd></td>
          <td>{{ 'vendas.atalhos.f10' | translate }}</td>
        </tr>

        <!-- Atalhos com Ctrl -->
        <tr class="atalhos-section-header">
          <td colspan="2"><strong>{{ 'vendas.atalhos.secao_ctrl' | translate }}</strong></td>
        </tr>
        <tr>
          <td><kbd>Ctrl</kbd> + <kbd>Enter</kbd></td>
          <td>{{ 'vendas.atalhos.ctrl_enter' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>Ctrl</kbd> + <kbd>D</kbd></td>
          <td>{{ 'vendas.atalhos.ctrl_d' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>Ctrl</kbd> + <kbd>H</kbd></td>
          <td>{{ 'vendas.atalhos.ctrl_h' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>Ctrl</kbd> + <kbd>Shift</kbd> + <kbd>Del</kbd></td>
          <td>{{ 'vendas.atalhos.ctrl_shift_del' | translate }}</td>
        </tr>

        <!-- Navegacao -->
        <tr class="atalhos-section-header">
          <td colspan="2"><strong>{{ 'vendas.atalhos.secao_navegacao' | translate }}</strong></td>
        </tr>
        <tr>
          <td><kbd>Alt</kbd> + <kbd>&rarr;</kbd></td>
          <td>{{ 'vendas.atalhos.alt_direita' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>Alt</kbd> + <kbd>&larr;</kbd></td>
          <td>{{ 'vendas.atalhos.alt_esquerda' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>Esc</kbd></td>
          <td>{{ 'vendas.atalhos.escape' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>Enter</kbd></td>
          <td>{{ 'vendas.atalhos.enter' | translate }}</td>
        </tr>

        <!-- Atalhos Contextuais -->
        <tr class="atalhos-section-header">
          <td colspan="2"><strong>{{ 'vendas.atalhos.secao_contextual' | translate }}</strong></td>
        </tr>
        <tr>
          <td><kbd>Ctrl</kbd> + <kbd>S</kbd></td>
          <td>{{ 'vendas.atalhos.ctrl_s' | translate }}</td>
        </tr>
        <tr>
          <td><kbd>Ctrl</kbd> + <kbd>P</kbd></td>
          <td>{{ 'vendas.atalhos.ctrl_p' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="mostrarDialogAtalhos = false">
      {{ 'vendas.buttons.fechar' | translate }} (Esc)
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog Variantes e Modificadores -->
<p-dialog
  [(visible)]="mostrarDialogVarianteModificador"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '500px', height: 'auto' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-list" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.variantes.dialog_titulo' | translate }}</h2>
        <p>{{ produtoParaVariante?.nome }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body variante-modificador-body">

    <!-- Loading state -->
    <div *ngIf="carregandoVariantes" class="vm-loading">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4"></p-progressSpinner>
      <span class="vm-loading-text">{{ 'vendas.variantes.carregando_opcoes' | translate }}</span>
    </div>

    <!-- Conteudo quando carregado -->
    <ng-container *ngIf="!carregandoVariantes">

      <!-- Produto sticky (imagem + nome + preco base) -->
      <div class="vm-produto-sticky" *ngIf="produtoParaVariante">
        <img
          *ngIf="produtoParaVariante.imagem"
          [src]="env.imgHost + '/' + idEmpresa + '/item/' + produtoParaVariante.imagem"
          class="vm-produto-img"
          [alt]="produtoParaVariante.nome"
          (error)="$any($event.target).style.display='none'">
        <div *ngIf="!produtoParaVariante.imagem" class="vm-produto-img-placeholder">
          <i class="pi pi-box"></i>
        </div>
        <div class="vm-produto-info">
          <span class="vm-produto-nome">{{ produtoParaVariante.nome }}</span>
          <span class="vm-produto-preco-base">
            {{ 'vendas.variantes.preco_base' | translate }}:
            <span *ngIf="moedaPadrao === 'PYG'">{{ produtoParaVariante.precoDeVenda | guaraniFormat }}</span>
            <span *ngIf="moedaPadrao !== 'PYG'">{{ produtoParaVariante.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
          </span>
        </div>
      </div>

      <!-- Estado vazio (sem variantes nem modificadores) -->
      <div *ngIf="variantesDisponiveis.length === 0 && gruposModificadores.length === 0" class="vm-empty-state">
        <i class="pi pi-info-circle"></i>
        <span>{{ 'vendas.variantes.sem_opcoes' | translate }}</span>
      </div>

      <!-- Secao de Variantes -->
      <div *ngIf="variantesDisponiveis.length > 0" class="vm-secao vm-secao-variante" [class.vm-secao-pendente]="!varianteSelecionada">
        <h3 class="vm-secao-titulo">
          <i class="pi pi-th-large vm-secao-icone"></i>
          <span class="vm-secao-titulo-texto">{{ 'vendas.variantes.selecionar_variante' | translate }}</span>
          <span class="vm-badge-obrigatorio" *ngIf="!varianteSelecionada">
            {{ 'vendas.variantes.obrigatorio' | translate }}
          </span>
          <span class="vm-badge-selecionado" *ngIf="varianteSelecionada">
            <i class="pi pi-check"></i> {{ 'vendas.variantes.selecionado' | translate }}
          </span>
        </h3>
        <p class="vm-secao-explicacao">{{ 'vendas.variantes.explicacao_variante' | translate }}</p>
        <div class="vm-opcoes-lista">
          <div
            *ngFor="let variante of variantesDisponiveis"
            class="vm-opcao"
            [class.vm-opcao-selecionada]="varianteSelecionada?.id === variante.id"
            (click)="selecionarVariante(variante)">
            <div class="vm-opcao-radio">
              <i [class]="varianteSelecionada?.id === variante.id ? 'pi pi-circle-fill' : 'pi pi-circle'"></i>
            </div>
            <div class="vm-opcao-info">
              <span class="vm-opcao-descricao">{{ variante.descricao }}</span>
            </div>
            <div class="vm-opcao-preco">
              <span *ngIf="moedaPadrao === 'PYG'">{{ variante.precoDeVenda | guaraniFormat }}</span>
              <span *ngIf="moedaPadrao !== 'PYG'">{{ variante.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Separador entre variantes e modificadores -->
      <div *ngIf="variantesDisponiveis.length > 0 && gruposModificadores.length > 0" class="vm-separador"></div>

      <!-- Secao de Modificadores (por grupo) -->
      <div *ngFor="let grupo of gruposModificadores" class="vm-secao vm-secao-modificador" [class.vm-secao-pendente]="isGrupoComMinimoPendente(grupo)">
        <h3 class="vm-secao-titulo">
          <i class="pi pi-plus-circle vm-secao-icone"></i>
          <span class="vm-secao-titulo-texto" [pTooltip]="grupo.descricao" tooltipPosition="top">{{ grupo.descricao }}</span>
          <!-- Contador dinamico -->
          <span class="vm-badge-contador" *ngIf="grupo.maximoDeModificadores > 0"
            [class.vm-badge-contador-cheio]="getTotalSelecoesGrupo(grupo.id!) >= grupo.maximoDeModificadores"
            [class.vm-badge-contador-pendente]="isGrupoComMinimoPendente(grupo)">
            {{ 'vendas.variantes.selecionados_contador' | translate:{ atual: getTotalSelecoesGrupo(grupo.id!), max: grupo.maximoDeModificadores } }}
          </span>
          <span class="vm-badge-obrigatorio" *ngIf="grupo.minimoDeModificadores > 0 && isGrupoComMinimoPendente(grupo)">
            {{ 'vendas.variantes.obrigatorio' | translate }}
          </span>
        </h3>
        <p class="vm-secao-explicacao">{{ 'vendas.variantes.explicacao_modificador' | translate }}</p>
        <!-- Aviso de minimo pendente -->
        <div *ngIf="isGrupoComMinimoPendente(grupo)" class="vm-aviso-minimo">
          <i class="pi pi-exclamation-triangle"></i>
          {{ 'vendas.variantes.selecione_pelo_menos' | translate:{ min: grupo.minimoDeModificadores } }}
        </div>
        <div class="vm-opcoes-lista">
          <!-- Modo RADIO: maximo = 1 -->
          <ng-container *ngIf="grupo.maximoDeModificadores === 1">
            <div
              *ngFor="let mod of grupo.modificadores"
              class="vm-opcao"
              [class.vm-opcao-selecionada]="isModificadorSelecionado(grupo.id!, mod.id!)"
              (click)="toggleModificador(grupo, mod)">
              <div class="vm-opcao-radio">
                <i [class]="isModificadorSelecionado(grupo.id!, mod.id!) ? 'pi pi-circle-fill' : 'pi pi-circle'"></i>
              </div>
              <div class="vm-opcao-info">
                <span class="vm-opcao-descricao">{{ mod.descricao }}</span>
              </div>
              <div class="vm-opcao-preco">
                <span *ngIf="moedaPadrao === 'PYG'">+{{ mod.precoDeVenda | guaraniFormat }}</span>
                <span *ngIf="moedaPadrao !== 'PYG'">+{{ mod.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
              </div>
            </div>
          </ng-container>

          <!-- Modo QUANTIDADE: maximo > 1 -->
          <ng-container *ngIf="grupo.maximoDeModificadores !== 1">
            <div
              *ngFor="let mod of grupo.modificadores"
              class="vm-opcao"
              [class.vm-opcao-selecionada]="isModificadorSelecionado(grupo.id!, mod.id!)">
              <div class="vm-opcao-info vm-opcao-info-qty">
                <span class="vm-opcao-descricao">{{ mod.descricao }}</span>
              </div>
              <div class="vm-qty-controles">
                <button
                  pButton
                  type="button"
                  icon="pi pi-minus"
                  class="p-button-rounded p-button-text p-button-sm vm-qty-btn"
                  [disabled]="getQuantidadeModificador(grupo.id!, mod.id!) <= 0"
                  (click)="decrementarModificador(grupo.id!, mod.id!); $event.stopPropagation()">
                </button>
                <span class="vm-qty-valor" [class.vm-qty-valor-ativo]="getQuantidadeModificador(grupo.id!, mod.id!) > 0">
                  {{ getQuantidadeModificador(grupo.id!, mod.id!) }}
                </span>
                <button
                  pButton
                  type="button"
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-text p-button-sm vm-qty-btn"
                  [disabled]="isGrupoMaxAtingido(grupo.id!, grupo.maximoDeModificadores)"
                  (click)="incrementarModificador(grupo, mod); $event.stopPropagation()">
                </button>
              </div>
              <div class="vm-opcao-preco">
                <ng-container *ngIf="getQuantidadeModificador(grupo.id!, mod.id!) > 0; else precoUnitario">
                  <span *ngIf="moedaPadrao === 'PYG'">+{{ mod.precoDeVenda * getQuantidadeModificador(grupo.id!, mod.id!) | guaraniFormat }}</span>
                  <span *ngIf="moedaPadrao !== 'PYG'">+{{ mod.precoDeVenda * getQuantidadeModificador(grupo.id!, mod.id!) | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
                </ng-container>
                <ng-template #precoUnitario>
                  <span class="vm-preco-unitario-hint">
                    <span *ngIf="moedaPadrao === 'PYG'">+{{ mod.precoDeVenda | guaraniFormat }}</span>
                    <span *ngIf="moedaPadrao !== 'PYG'">+{{ mod.precoDeVenda | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
                  </span>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Preco Final sticky com breakdown -->
      <div class="vm-preco-final">
        <!-- Breakdown detalhado -->
        <div class="vm-preco-breakdown" *ngIf="breakdownPreco.length > 1">
          <div *ngFor="let item of breakdownPreco" class="vm-breakdown-item">
            <span class="vm-breakdown-desc">
              <span *ngIf="item.tipo === 'modificador'">+ </span>{{ item.descricao }}<span *ngIf="item.quantidade && item.quantidade > 1"> (x{{ item.quantidade }})</span>
            </span>
            <span class="vm-breakdown-valor">
              <span *ngIf="item.tipo === 'modificador'">+</span>
              <span *ngIf="moedaPadrao === 'PYG'">{{ item.valor | guaraniFormat }}</span>
              <span *ngIf="moedaPadrao !== 'PYG'">{{ item.valor | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
            </span>
          </div>
          <div class="vm-breakdown-separador"></div>
        </div>
        <!-- Total -->
        <div class="vm-preco-final-row">
          <span class="vm-preco-final-label">{{ 'vendas.variantes.preco_final' | translate }}:</span>
          <span class="vm-preco-final-valor" *ngIf="precoCalculadoVariante > 0">
            <span *ngIf="moedaPadrao === 'PYG'">{{ precoCalculadoVariante | guaraniFormat }}</span>
            <span *ngIf="moedaPadrao !== 'PYG'">{{ precoCalculadoVariante | moedaSimbolo: moedaPadrao:digitsMoeda:localeMoeda }}</span>
          </span>
          <span class="vm-preco-final-placeholder" *ngIf="precoCalculadoVariante === 0">
            {{ 'vendas.variantes.selecione_opcao' | translate }}
          </span>
        </div>
      </div>

    </ng-container>
  </div>

  <ng-template pTemplate="footer">
    <div class="vm-footer-wrapper">
      <!-- Mensagem de validacao acima dos botoes -->
      <div class="vm-validacao-msg" *ngIf="!podeConfirmarVarianteModificador && !carregandoVariantes && (variantesDisponiveis.length > 0 || gruposModificadores.length > 0)">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ mensagemValidacaoVariante }}</span>
      </div>
      <div class="vm-footer-buttons">
      <button pButton class="p-button-text p-button-secondary" (click)="fecharDialogVarianteModificador()">
        {{ 'vendas.buttons.cancelar' | translate }}
      </button>
      <button pButton icon="pi pi-check"
        [disabled]="!podeConfirmarVarianteModificador"
        (click)="confirmarSelecaoVarianteModificador()">
        {{ 'vendas.variantes.confirmar_enter' | translate }}
      </button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog Limite do Plano Atingido -->
<p-dialog
  [(visible)]="mostrarDialogLimitePlano"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '420px', height: 'auto' }">

  <!-- HEADER COM WAVE (variante warning) -->
  <div class="dialog-wave-header dialog-wave-header--warning">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-chart-bar" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'limite_plano.titulo' | translate }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <p *ngIf="temPermissaoConfiguracao">{{ 'limite_plano.mensagem' | translate }}</p>
    <p *ngIf="!temPermissaoConfiguracao">{{ 'limite_plano.sem_permissao' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary" (click)="mostrarDialogLimitePlano = false">
      {{ 'limite_plano.fechar' | translate }}
    </button>
    <button
      *ngIf="temPermissaoConfiguracao"
      pButton
      icon="pi pi-arrow-right"
      (click)="navegarParaPlanos()">
      {{ 'limite_plano.ver_planos' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog Selecao do Multiplicador -->
<!-- Acionado por "<qtd>*<termo>" quando ha multiplos itens (sem match exato). -->
<!-- Reusa classes .vm-opcao / .vm-opcao-info / .vm-opcao-preco do dialog de variantes. -->
<p-dialog
  [(visible)]="mostrarDialogSelecaoMultiplicador"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '500px', height: 'auto' }"
  [contentStyle]="{ 'max-height': '70vh', 'overflow-y': 'auto' }">

  <!-- HEADER COM WAVE -->
  <div class="dialog-wave-header">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-search-plus" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ 'vendas.dialogs.selecao_multiplicador_titulo' | translate }}</h2>
        <p>{{ 'vendas.dialogs.selecao_multiplicador_desc' | translate:{ quantidade: quantidadeDialogSelecao } }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body selecao-multiplicador-body">

    <!-- Lista de itens (reusa .vm-opcao) -->
    <div class="vm-opcoes-lista">
      <div
        *ngFor="let item of itensDialogSelecaoPaginados"
        class="vm-opcao"
        (click)="selecionarItemDoDialog(item)">
        <div class="vm-opcao-info">
          <span class="vm-opcao-descricao"><strong>{{ item.nome }}</strong></span>
          <small class="selecao-multiplicador-cod">{{ 'vendas.table.cod' | translate }} {{ item.codigoItem }}</small>
        </div>
        <div class="vm-opcao-preco">
          <span *ngIf="moedaPadrao === 'PYG'">{{ item.precoDeVenda | guaraniFormat }}</span>
          <span *ngIf="moedaPadrao !== 'PYG'">{{ item.precoDeVenda | currency: moedaPadrao:'symbol':digitsMoeda:localeMoeda }}</span>
        </div>
      </div>
    </div>

    <!-- Paginacao client-side (so aparece quando ha mais de uma pagina) -->
    <div *ngIf="itensDialogSelecao.length > tamanhoPaginaDialog"
         class="selecao-multiplicador-paginator">
      <p-paginator
        [rows]="tamanhoPaginaDialog"
        [totalRecords]="itensDialogSelecao.length"
        [first]="paginaAtualDialog * tamanhoPaginaDialog"
        [showCurrentPageReport]="false"
        [showPageLinks]="true"
        (onPageChange)="onPaginaDialogChange($event)">
      </p-paginator>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="p-button-text p-button-secondary"
      (click)="cancelarDialogSelecaoMultiplicador()">
      {{ 'vendas.buttons.cancelar' | translate }}
    </button>
  </ng-template>
</p-dialog>

<!-- Detalhe do produto (modal central) - lazy: GET das imagens secundarias so apos click -->
<app-vendas-produto-detalhe
  *ngIf="produtoDetalheAberto"
  [produto]="produtoDetalheAberto"
  [idEmpresa]="idEmpresa"
  [moedaPadrao]="moedaPadrao"
  [digitsMoeda]="digitsMoeda"
  [localeMoeda]="localeMoeda"
  (adicionarAoCarrinho)="onAdicionarDoDetalhe($event)"
  (fechar)="produtoDetalheAberto = null">
</app-vendas-produto-detalhe>

<!--
  Popup de importacao de pedido. Fica com *ngIf para o componente nascer ja carregando a lista e
  morrer ao fechar, sem estado velho na proxima abertura.
-->
<app-importar-pedido-dialog
  *ngIf="mostrarDialogImportarPedido"
  (fechado)="mostrarDialogImportarPedido = false"
  (importado)="onPedidoImportado()">
</app-importar-pedido-dialog>

<!-- Dialog: observacao por item do carrinho (paridade com Criar Pedido) -->
<p-dialog
  [(visible)]="mostrarDialogObservacaoItem"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [header]="'criar_pedido.observacao_item_titulo' | translate"
  [style]="{ width: '30rem', maxWidth: '94vw' }"
  styleClass="dialog-observacao-item"
  (onHide)="fecharObservacaoItem()">
  <div class="obs-item-body">
    <label for="obs-item-textarea">{{ 'criar_pedido.observacao_item_label' | translate }}</label>
    <textarea
      id="obs-item-textarea"
      pInputTextarea
      rows="4"
      maxlength="500"
      class="w-full"
      [(ngModel)]="observacaoItemEmEdicao"
      [placeholder]="'criar_pedido.observacao_item_ph' | translate"></textarea>
  </div>
  <ng-template pTemplate="footer">
    <button pButton class="p-button-secondary"
      [label]="'criar_pedido.cancelar' | translate"
      (click)="mostrarDialogObservacaoItem = false">
    </button>
    <button pButton icon="pi pi-check"
      [label]="'criar_pedido.observacao_item_salvar' | translate"
      (click)="salvarObservacaoItem()">
    </button>
  </ng-template>
</p-dialog>
